import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { Button, Card, Spinner } from "@/components/ui/Primitives";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const nav = useNavigate();
  const [tries, setTries] = useState(0);
  const [status, setStatus] = useState("checking"); // checking | ok | error
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    if (!sid) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/subscription/session/${sid}`);
        if (cancelled) return;
        if (data.status === "complete" || data.payment_status === "paid") {
          setDetail(data);
          setStatus("ok");
        } else {
          setTries((t) => t + 1);
          if (tries < 10) setTimeout(poll, 2000);
          else setStatus("error");
        }
      } catch (_) {
        setStatus("error");
      }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sid]);

  return (
    <Layout title="Pagamento — Confirmação">
      <div className="max-w-lg mx-auto">
        <Card className="p-8 text-center">
          {status === "checking" && (
            <>
              <Spinner size={40} />
              <h2 className="mt-4 font-heading text-xl font-bold text-ink-900">Confirmando pagamento...</h2>
              <p className="text-sm text-ink-500 mt-2">Aguarde alguns instantes.</p>
            </>
          )}
          {status === "ok" && (
            <>
              <div className="w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mx-auto">
                <CheckCircle2 size={44} className="text-emerald-600" />
              </div>
              <h2 className="mt-4 font-heading text-2xl font-bold text-ink-900">Assinatura ativa!</h2>
              <p className="text-sm text-ink-500 mt-2">Seu plano Serenata ERP está ativo. Bom uso!</p>
              <div className="mt-6 flex flex-col sm:flex-row gap-2 justify-center">
                <Link to="/assinatura"><Button variant="secondary">Ver detalhes</Button></Link>
                <Button onClick={() => nav("/")}>Ir para o painel</Button>
              </div>
            </>
          )}
          {status === "error" && (
            <>
              <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mx-auto">
                <XCircle size={44} className="text-danger" />
              </div>
              <h2 className="mt-4 font-heading text-xl font-bold text-ink-900">Não foi possível confirmar</h2>
              <p className="text-sm text-ink-500 mt-2">Se o pagamento foi cobrado, a assinatura será ativada em alguns minutos.</p>
              <div className="mt-4">
                <Link to="/assinatura"><Button>Ver status</Button></Link>
              </div>
            </>
          )}
        </Card>
      </div>
    </Layout>
  );
}

export function PaymentCancel() {
  return (
    <Layout title="Pagamento cancelado">
      <div className="max-w-lg mx-auto">
        <Card className="p-8 text-center">
          <div className="w-20 h-20 rounded-full bg-stone-100 flex items-center justify-center mx-auto">
            <XCircle size={44} className="text-ink-500" />
          </div>
          <h2 className="mt-4 font-heading text-xl font-bold text-ink-900">Pagamento cancelado</h2>
          <p className="text-sm text-ink-500 mt-2">Você pode ativar a assinatura quando quiser.</p>
          <div className="mt-4">
            <Link to="/assinatura"><Button>Voltar para Assinatura</Button></Link>
          </div>
        </Card>
      </div>
    </Layout>
  );
}
